import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { FaTimes } from "react-icons/fa";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { closeConfirmationPopup } from "../../../Redux/Actions/PopupActions";
import {
  deleteVideo,
  sendHighlightRequest,
} from "../../../Redux/Actions/VideoLibraryActions";
import { deleteVideoFromPastSeason } from "../../../Redux/Actions/PastSeasonActions";
import { deleteVideoFromStorageManagement } from "../../../Redux/Actions/StorageManagementActions";
import { removeUploadedVideo } from "../../../Redux/Actions/UploadVideoAction";
import { deleteIntercutVideo } from "../../../Redux/Actions/IntercutVideoActions";
import { resetPasswordThroughEmail } from "../../../Redux/Actions/UserSettingActions";
import {
  activateDeactivateSchool,
  deleteContactUsInquiry,
  deleteSchool,
  restoreDeletedSchool,
} from "../../../Redux/Actions/SuperAdminDashboardActions";
import {
  activateOrDeactivateGroup,
  deleteGroup,
} from "../../../Redux/Actions/GroupActions";
import { deleteFilter } from "../../../Redux/Actions/VideoLibraryFilterAction";
import {
  activateInactivateTeamAdmin,
  deleteTeamAdmin,
} from "../../../Redux/Actions/TeamAdminActions";
import {
  activateInactivateCoach,
  deleteCoach,
} from "../../../Redux/Actions/CoachActions";
import {
  activateInactivateAthlete,
  deleteAthlete,
} from "../../../Redux/Actions/AthleteActions";
import {
  deleteAllIvsChannels,
  deleteIvsChannel,
  deleteRecordedVideo,
  requestIPCameraDisconnection,
  startVideoStream,
  stopVideoStream,
} from "../../../Redux/Actions/VideoStreamingActions";
import { deleteBreakdown } from "../../../Redux/Actions/ManageBreakDownAction";
import {
  approveBreakdownRequest,
  deleteBreakdownrequest,
  disApproveBreakdownRequest,
  deleteCreateHighlightRequest,
} from "../../../Redux/Actions/BreakdownRequestsDataAction";
import { deleteColumnSet } from "../../../Redux/Actions/VideoLibraryDataTableActions";

const ConfirmationDialog = ({
  confirmPopUp,
  toggleConfirmDialog,
  btnColor,
  btnText,
  msg,
  icon,
  messageDialog,
}) => {
  const confirmationPopup = useSelector(
    (state) => state?.popupInformation?.confirmationPopup
  );
  const confirmationAction = useSelector(
    (state) => state?.popupInformation?.confirmationAction
  );
  const { filteredTableData, tableData, selectedVideo } = useSelector(
    (state) => state?.VideoLibraryDataTable
  );
  const videoLibraryData = useSelector((state) => state?.videoLibraryData);
  const dispatch = useDispatch();
  const history = useHistory();
  const handleApi = (event) => {
    event.stopPropagation();
    switch (confirmationPopup.type) {
      case "Delete contact us inquiry":
        deleteContactUsInquiry(dispatch, {
          apiToCall: confirmationPopup.apiToCall,
          id: confirmationPopup?.id,
        });
        break;

      case "Delete all IVS channel":
        deleteAllIvsChannels(dispatch, {
          item: confirmationPopup.item,
          socket: confirmationPopup.socket,
          getAllLiveChannel: confirmationPopup.getAllLiveChannel,
          setLoadingButton: confirmationPopup.setLoadingButton,
        });
        break;

      case "Delete IVS channel":
        deleteIvsChannel(dispatch, {
          item: confirmationPopup.item,
          socket: confirmationPopup.socket,
          getAllLiveChannel: confirmationPopup.getAllLiveChannel,
          setLoadingButton: confirmationPopup.setLoadingButton,
          userId: confirmationPopup?.userId,
        });
        break;

      case "Delete recording":
        deleteRecordedVideo(dispatch, {
          id: confirmationPopup.id,
          recording: confirmationPopup.recording,
        });
        break;

      case "Delete Video":
        deleteVideo(dispatch, {
          eventMediaId: [confirmationPopup.eventMediaId],
          seasonType: confirmationPopup.seasonType,
          eventType: confirmationPopup.eventType,
          weekName: confirmationPopup.weekName,
          offSeasonEventName: confirmationPopup.offSeasonEventName,
          practiceName: confirmationPopup.practiceName,
          otherSeasonEventType: confirmationPopup.otherSeasonEventType,
          videoId: [confirmationPopup.videoId],
          newVideoName: null,
          isVideoRenamed: false,
          playlistId: confirmationPopup.playlistId,
          inSeasonData: videoLibraryData.inSeasonData,
          offSeasonData: videoLibraryData.offSeasonData,
          otherSeasonData: videoLibraryData.otherSeasonData,
          seasonName: confirmationPopup.seasonName,
          isVideoFromHighlight: confirmationPopup.isVideoFromHighlight,
          selectedVideoPaths: confirmationPopup.selectedVideoPaths,
          tableData: tableData,
          filteredTableData: filteredTableData,
          selectedVideo: selectedVideo,
          setVideoPath: confirmationPopup.setVideoPath,
        });
        break;

      case "Delete Video From Past Season":
        deleteVideoFromPastSeason(dispatch, {
          eventMediaId: confirmationPopup.eventMediaId,
          seasonType: confirmationPopup.seasonType,
          eventType: confirmationPopup.eventType,
          weekName: confirmationPopup.weekName,
          videoId: confirmationPopup.eventMediaId,
          newVideoName: null,
          isVideoRenamed: false,
          seasonName: confirmationPopup.seasonName,
          offSeasonEventName: confirmationPopup.offSeasonEventName,
          practiceName: confirmationPopup.practiceName,
          otherSeasonEventType: confirmationPopup.otherSeasonEventType,
        });
        break;

      case "Delete Video From Storage Management":
        deleteVideoFromStorageManagement(dispatch, {
          videoIds: confirmationPopup.videoIds,
          userId: confirmationPopup.userId,
          page: confirmationPopup.page,
          pageSize: confirmationPopup.pageSize,
          searchQuery: confirmationPopup.searchQuery,
          isRecordSearched: confirmationPopup.isRecordSearched,
        });
        break;

      case "Remove Uploaded Video From Upload Video Page":
        removeUploadedVideo(dispatch, {
          currentUserId: confirmationPopup.currentUserId,
          authorization: confirmationPopup.authorization,
          uploadVideoCountToShow: confirmationPopup.uploadVideoCountToShow,
          selectedFileKey: confirmationPopup.selectedFileKey,
          selectedFileIndex: confirmationPopup.selectedFileIndex,
        });
        break;

      case "Delete Intercut Video":
        deleteIntercutVideo(dispatch, {
          id: confirmationPopup.eventMediaId,
          angleName: confirmationPopup.angleName,
          listName: confirmationPopup.listName,
        });
        break;

      case "Reset Password":
        resetPasswordThroughEmail(dispatch, {
          email: confirmationPopup.email,
        });
        break;

      case "School Delete":
        deleteSchool(dispatch, { schoolId: confirmationPopup.id });
        break;

      case "School Restore":
        restoreDeletedSchool(dispatch, {
          schoolId: confirmationPopup.id,
        });
        break;

      case "School Activate / Deactivate":
        activateDeactivateSchool(dispatch, {
          schoolId: confirmationPopup.id,
          status: confirmationPopup.status,
        });
        break;

      case "Video Highlight":
        sendHighlightRequest(dispatch, confirmationPopup);
        break;

      case "Delete Column Set":
        deleteColumnSet(dispatch, {
          id: confirmationPopup?.data?.id,
          apiCall: confirmationAction,
        });
        break;

      case "Add Team Admin":
        closeConfirmationPopup(dispatch, false);
        history.push("/teamadmin");
        break;

      case "Edit Team Admin":
        closeConfirmationPopup(dispatch, false);
        history.push(`/teamadmindetails/${confirmationPopup?.id}`);
        break;

      case "Add Coach":
        closeConfirmationPopup(dispatch, false);
        history.push("/schoolcoaches");
        break;

      case "Edit Coach":
        closeConfirmationPopup(dispatch, false);
        history.push(`/coachesdetails/${confirmationPopup?.id}`);
        break;

      case "Add Athlete":
        closeConfirmationPopup(dispatch, false);
        history.push("/schoolathletes");
        break;

      case "Edit Athlete":
        closeConfirmationPopup(dispatch, false);
        history.push(`/athletedetails/${confirmationPopup?.id}`);
        break;

      case "Edit School Details":
        closeConfirmationPopup(dispatch, false);
        history.push(`/schoolnamescreen/${confirmationPopup?.id}`);
        break;

      case "Add School Details":
        closeConfirmationPopup(dispatch, false);
        history.push("/schools");
        break;

      case "Add Billing Details":
        closeConfirmationPopup(dispatch, false);
        history.push("/payment");
        break;

      case "Edit Sport" || "Add Sport":
        closeConfirmationPopup(dispatch, false);
        history.push("/sports");
        break;

      case "Profile Edit Page":
        closeConfirmationPopup(dispatch, false);
        history.push("/pfmanagement");
        break;

      case "Edit Group":
        closeConfirmationPopup(dispatch, false);
        history.push(`/groupdetails/${confirmationPopup?.id}`);
        break;

      case "Coach Profile Edit":
        closeConfirmationPopup(dispatch, false);
        history.push(confirmationPopup.cancelLink);
        break;

      case "Athlete Profile Edit":
        closeConfirmationPopup(dispatch, false);
        history.push(confirmationPopup.cancelLink);
        break;

      case "Team Admin Profile Edit":
        closeConfirmationPopup(dispatch, false);
        history.push(confirmationPopup.cancelLink);
        break;

      case "Activate Deactivate Group":
        activateOrDeactivateGroup(dispatch, {
          id: confirmationPopup.id,
          status: confirmationPopup.status,
        });
        break;

      case "Delete Group":
        deleteGroup(dispatch, { id: confirmationPopup.id });
        break;

      case "Add Group":
        closeConfirmationPopup(dispatch, false);
        history.push(confirmationPopup.cancelLink);
        break;

      case "Delete Filter":
        deleteFilter(dispatch, { id: confirmationPopup.id });
        break;

      case "Team Admin Delete":
        deleteTeamAdmin(dispatch, { id: confirmationPopup?.id });
        break;

      case "Team Admin Activate / Deactivate":
        activateInactivateTeamAdmin(dispatch, {
          id: confirmationPopup?.id,
          status: confirmationPopup?.status,
        });
        break;

      case "Coach Activate / Deactivate":
        activateInactivateCoach(dispatch, {
          id: confirmationPopup?.id,
          status: confirmationPopup?.status,
        });
        break;

      case "Athlete Delete":
        deleteAthlete(dispatch, { id: confirmationPopup?.id });
        break;

      case "Coach Delete":
        deleteCoach(dispatch, { id: confirmationPopup?.id });
        break;

      case "Athlete Activate / Deactivate":
        activateInactivateAthlete(dispatch, {
          id: confirmationPopup?.id,
          status: confirmationPopup?.status,
        });
        break;

      case "Add / Edit Athlete":
        closeConfirmationPopup(dispatch, false);
        confirmationPopup?.id
          ? history.push(`/athletedetails/${confirmationPopup?.id}`)
          : history.push("/schoolathletes");
        break;

      case "Add / Edit Coach":
        closeConfirmationPopup(dispatch, false);
        confirmationPopup?.id
          ? history.push(`/coachesdetails/${confirmationPopup?.id}`)
          : history.push("/schoolcoaches");
        break;

      case "Create Video Stream Channel":
        closeConfirmationPopup(dispatch, false);
        history.push("/website");
        break;

      case "Live Streaming":
        closeConfirmationPopup(dispatch, false);
        break;

      case "Start Channels":
        startVideoStream(dispatch, confirmationPopup?.channelIds);
        break;

      case "Stop Channels":
        stopVideoStream(dispatch, confirmationPopup?.channelIds);
        break;

      case "IP Camera Disconnection":
        requestIPCameraDisconnection(
          dispatch,
          confirmationPopup?.cameraDetails
        );
        break;

      case "Delete Breakdown":
        deleteBreakdown(dispatch, {
          id: confirmationPopup?.breakDownId,
          breakDownList: confirmationPopup?.breakDownList,
          searchedRecord: confirmationPopup?.searchedRecord,
          searchQuery: confirmationPopup?.searchQuery,
          schoolId: confirmationPopup?.schoolId,
          currentUserId: confirmationPopup?.currentUserId,
        });
        break;

      case "Delete Breakdown Request":
        deleteBreakdownrequest(dispatch, {
          id: confirmationPopup?.id,
          breakdownRequestData: confirmationPopup?.breakdownRequestData,
        });
        break;

      case "Delete create highlight Request":
        deleteCreateHighlightRequest(dispatch, {
          id: confirmationPopup?.id,
          shareMediaId: confirmationPopup?.shareMediaId,
          apiCall: confirmationAction,
        });
        break;

      case "Approve Breakdown Request":
        approveBreakdownRequest(dispatch, {
          id: confirmationPopup?.id,
          breakdownRequestData: confirmationPopup?.breakdownRequestData,
        });

      case "Disapprove Breakdown Request":
        disApproveBreakdownRequest(dispatch, {
          id: confirmationPopup?.id,
          breakdownRequestData: confirmationPopup?.breakdownRequestData,
        });

      default:
        break;
    }
  };

  return (
    <Dialog
      id="dialogBoxRemove"
      className="dialog-stylee"
      open={confirmPopUp}
      onClose={() => toggleConfirmDialog(false)}
      maxWidth="sm"
    >
      <DialogTitle>
        <div className="row">
          <div className="col-1 text-right ml-auto">
            <FaTimes
              onClick={(event) => {
                event.stopPropagation();
                toggleConfirmDialog();
              }}
              className="crossview cp"
            />
          </div>
        </div>
      </DialogTitle>
      <DialogContent>
        <div className="clear10"></div>
        <div className="row">
          <div className="col-12 text-center">
            {icon ? icon : null}
            <p className="fs-20 semi-bold text-center mb-4">{msg}</p>
          </div>
          <div className="d-flex align-items-center justify-content-center gap-10 w-100">
            <button
              type="button"
              class={messageDialog ? "green-btn" : "cancelbtn"}
              onClick={(event) => {
                event.stopPropagation();
                toggleConfirmDialog(false);
              }}
            >
              {messageDialog ? "Ok" : "No"}
            </button>
            {!messageDialog && (
              <button
                type="button"
                className={btnColor == "green" ? "green-btn" : "yes-btn"}
                onClick={(event) => {
                  handleApi(event);
                }}
              >
                {btnText}
              </button>
            )}
          </div>
        </div>
        <div className="clear10"></div>
        <div className="clear10"></div>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmationDialog;
